import { useEffect,  useState } from "react";
import meImage from "../../../assets/me.jpg";
import bdIcon from "../../../assets/bdIcon.gif";
import eye from "../../../assets/eye.gif";
import { Countdown } from "../BirthdayCountDown/Countdown";
import DiscordActivity from "../DiscordActivity/DiscordActivity";
import { ShowMedia } from "./ShowSocialMedia/ShowSocialMedia";
import { Badges } from "../Badges/Badges";
import { Log } from "./log/Log";
import "./profile.css";
import "./ShowSocialMedia/showSocialMedia.css";

export function Profile() {
  const [isShown, setIsShown] = useState(false);
  const [showLog, setShowLog] = useState(false);
  const [totalTimeAlive, setTotalTimeAlive] = useState("");
  

  // js date is weird
  // gets de % of the year passed since last birthday
  useEffect(() => {
    function updateTimeAlive() {
      const now = new Date();
      const lastBirthday = new Date(now.getFullYear(), 1, 21);
      const nextBirthday = new Date(now.getFullYear() + 1, 1, 21);
      const fraction =
        (now.getTime() - lastBirthday.getTime()) /
        (nextBirthday.getTime() - lastBirthday.getTime());

      let age = now.getFullYear() - new Date(2006, 1, 21).getFullYear();
      let newTotalTimeAlive = (age + fraction).toFixed(7);

      setTotalTimeAlive(newTotalTimeAlive);
    }
    updateTimeAlive();

    const interval = setInterval(updateTimeAlive, 250);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="log-button-container">
        <button className="log-button" onClick={() => setShowLog(true)}>
          <span> LOG </span>
        </button>
        {" "}
        <a href="https://yapping-chat.onrender.com/" className="yap-chat" rel="noreferrer" target="_blank"> 
          <button className="log-button"> <span> yap chat</span></button>
        </a>
      </div>
      <Log isOpen={showLog} onClose={() => setShowLog(false)} />
      <div className="name-container">
        <h1 className="my-name"> Aike </h1>
        <img src={eye} alt="eye" className="my-icon"></img>
      </div>
      {/* <h3> Visitors </h3>, <Countdown icon={eye} count={1} /> sad...*/}
      <div className="photo-media-container">
        <div className="profile-photo" onClick={() => setIsShown(!isShown)}>
          <img src={meImage} alt="test" />
          <div className="spider-body">
            <div className="spider-leg1"> </div>
            <div className="spider-leg2"> </div>
            <div className="spider-leg3"> </div>
            <div className="spider-leg4"> </div>
            <div className="spider-head"> </div>
            <div className="spider-leg5"> </div>
            <div className="spider-leg6"> </div>
            <div className="spider-leg7"> </div>
            <div className="spider-leg8"> </div>
          </div>
        </div>
        <ShowMedia />
      </div>
      <Countdown icon={bdIcon} count={totalTimeAlive} />
      <DiscordActivity />
      <Badges />
    </div>
  );
}

export default Profile;
